import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col, Row, Button, Label, Input, Table, Modal, ModalHeader, ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";

/**
 * Traspasos de material: que se le mando a cada maquilero y que regreso.
 *
 * Cancelar no borra: el back aplica los movimientos inversos y deja el
 * documento marcado, asi que el kardex conserva las cuatro afectaciones.
 */
function ListadoTraspasosMateriales() {
  const { user } = useContext(AuthContext);
  const URL_TRASPASOS_MATERIALES = process.env.REACT_APP_URL_TRASPASOS_MATERIALES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;

  const hoy = moment(new Date()).format("YYYY-MM-DD");
  const haceUnMes = moment(new Date()).subtract(1, "months").format("YYYY-MM-DD");

  const [traspasos, setTraspasos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [fechaInicio, setFechaInicio] = useState(haceUnMes);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [filtroAlmacen, setFiltroAlmacen] = useState("");

  const [modalDetalle, setModalDetalle] = useState(false);
  const toggleDetalle = () => setModalDetalle(!modalDetalle);
  const [detalle, setDetalle] = useState({ traspaso: null, renglones: [] });

  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const cargar = () => {
    let url = `${URL_TRASPASOS_MATERIALES}?inicio=${fechaInicio}&fin=${fechaFin}`;
    if (filtroAlmacen) url += `&areaDestino=${filtroAlmacen}`;
    axios
      .get(url, { headers })
      .then((res) => setTraspasos(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    cargar();
  }, [fechaInicio, fechaFin, filtroAlmacen]);

  useEffect(() => {
    axios
      .get(URL_AREAS, { headers })
      .then((res) => setAreas(res.data))
      .catch((err) => console.log(err));
  }, []);

  const verDetalle = (id) => {
    axios
      .get(`${URL_TRASPASOS_MATERIALES}/${id}`, { headers })
      .then((res) => {
        setDetalle(res.data);
        toggleDetalle();
      })
      .catch((err) => console.log(err));
  };

  const cancelar = async (traspaso) => {
    const { value: motivo, isConfirmed } = await Swal.fire({
      title: `Cancelar traspaso #${traspaso.idTraspasoMaterial}`,
      text: "El material regresa al almacen de origen. El traspaso no se borra, queda marcado como cancelado.",
      input: "text",
      inputPlaceholder: "Motivo",
      showCancelButton: true,
      confirmButtonText: "Cancelar traspaso",
      cancelButtonText: "Cerrar",
    });
    if (!isConfirmed) return;

    try {
      await axios.patch(
        `${URL_TRASPASOS_MATERIALES}/${traspaso._id}/cancelar`,
        { motivo: motivo || "NA", fecha: hoy },
        { headers }
      );
      Swal.fire({ icon: "success", title: "Traspaso cancelado", showConfirmButton: false, timer: 2000 });
      cargar();
    } catch (error) {
      const data = error.response ? error.response.data : {};
      const faltantes = (data.faltantes || [])
        .map((f) => `${f.material}${f.color ? ` (${f.color})` : ""} en ${f.almacen}: faltan ${f.faltante}`)
        .join("<br/>");
      Swal.fire({
        icon: "error",
        title: "No se pudo cancelar",
        html: faltantes
          ? `El destino ya consumio parte del material:<br/>${faltantes}`
          : data.message || "Algo salio mal",
      });
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_telas ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-exchange-alt" style={{ marginRight: 8, color: "#0ea5e9" }} />
                Traspasos de Material
              </h3>
              <p className="page-subtitle">Tela y habilitacion movida entre bodega y maquileros</p>
            </div>
            <Button href="/TraspasosMaterialesCreate" className="btn btn-success">
              <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo
            </Button>
          </div>

          <Row style={{ marginBottom: 16 }}>
            <Col md={2}>
              <Label>Desde</Label>
              <Input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
            </Col>
            <Col md={2}>
              <Label>Hasta</Label>
              <Input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Almacen destino</Label>
              <Input type="select" value={filtroAlmacen} onChange={(e) => setFiltroAlmacen(e.target.value)}>
                <option value="">Todos</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => (
                    <option value={a._id} key={a._id}>
                      {a.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>

          <Table size="sm" striped borderless responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Orden Maquila</th>
                <th>Observaciones</th>
                <th>Status</th>
                <th>Detalle</th>
                <th>Cancelar</th>
              </tr>
            </thead>
            <tbody>
              {traspasos.map((a) => (
                <tr key={a._id} style={{ opacity: a.status === "Cancelado" ? 0.55 : 1 }}>
                  <td>{a.idTraspasoMaterial}</td>
                  <td>{a.fecha}</td>
                  <td>{a.areaSalida ? a.areaSalida.name : ""}</td>
                  <td>{a.areaDestino ? a.areaDestino.name : ""}</td>
                  <td>{a.cortes ? a.cortes.numero || a.cortes.idCorte : ""}</td>
                  <td>{a.observaciones}</td>
                  <td>
                    <span style={{ color: a.status === "Cancelado" ? "#dc2626" : "#16a34a", fontWeight: 600 }}>
                      {a.status}
                    </span>
                  </td>
                  <td>
                    <Button title="Ver detalle" size="sm" color="info" className="btn" onClick={() => verDetalle(a._id)}>
                      <i className="fas fa-eye" />
                    </Button>
                  </td>
                  <td>
                    {a.status === "Aplicado" ? (
                      <Button title="Cancelar" size="sm" color="danger" className="btn" onClick={() => cancelar(a)}>
                        <i className="fas fa-times" />
                      </Button>
                    ) : (
                      <span style={{ fontSize: "0.75rem", color: "#94a3b8" }}>{a.motivoCancelacion}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {traspasos.length === 0 ? (
            <p style={{ textAlign: "center", color: "#94a3b8" }}>Sin traspasos en el periodo</p>
          ) : undefined}

          <Modal size="lg" isOpen={modalDetalle} toggle={toggleDetalle}>
            <ModalHeader toggle={toggleDetalle}>
              <h4>
                Traspaso #{detalle.traspaso ? detalle.traspaso.idTraspasoMaterial : ""}
              </h4>
            </ModalHeader>
            <ModalBody>
              {detalle.traspaso ? (
                <p>
                  {detalle.traspaso.areaSalida.name} → {detalle.traspaso.areaDestino.name} ·{" "}
                  {detalle.traspaso.fecha}
                </p>
              ) : undefined}
              <Table size="sm" striped>
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Material</th>
                    <th>Color</th>
                    <th>Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  {detalle.renglones.map((r) => (
                    <tr key={r._id}>
                      <td>{r.tipoMaterial === "Telas" ? "Tela" : "Habilitacion"}</td>
                      <td>{r.material ? r.material.nombre : ""}</td>
                      <td>{r.colores ? r.colores.name : "-"}</td>
                      <td>{r.cantidad}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ListadoTraspasosMateriales;
